import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';

function LanguageSelector() {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'pt', name: 'Português', countryCode: 'BR' },
    { code: 'en', name: 'English', countryCode: 'US' },
    { code: 'es', name: 'Español', countryCode: 'ES' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // Salvar preferência no localStorage
    localStorage.setItem('i18nextLng', lng);
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative group">
      <button
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-stone-100 transition-colors text-stone-700 font-medium text-sm"
        aria-label="Seletor de idioma"
      >
        <ReactCountryFlag
          countryCode={currentLanguage.countryCode}
          svg
          style={{
            width: '1.25rem',
            height: '1.25rem',
          }}
          title={currentLanguage.name}
        />
        <span className="uppercase font-semibold">{currentLanguage.code}</span>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      <div className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border border-stone-200 py-2 min-w-[120px] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`w-full text-left px-4 py-2 hover:bg-stone-100 transition-colors flex items-center gap-3 ${
              i18n.language === lang.code ? 'bg-stone-100 font-semibold' : ''
            }`}
          >
            <ReactCountryFlag
              countryCode={lang.countryCode}
              svg
              style={{
                width: '1.25rem',
                height: '1.25rem',
              }}
              title={lang.name}
            />
            <span className="uppercase font-semibold">{lang.code}</span>
            {i18n.language === lang.code && (
              <svg className="w-4 h-4 ml-auto text-orange-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default LanguageSelector;

